export default __webpack_public_path__ + "static/media/Alcohol-HEAD-Mobile.e5b817d1.png";